import React from 'react';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import { getTextView } from './helpers';
import type { TProps } from './models';
import styles from './styles.css';

export const Plate = ({
    CorePlate,
    Text,
    buttons,
    children,
    className,
    config,
    leftAddons,
    rounded,
    subAddons,
    title,
    titleView,
    view,
    ...restProps
}: TProps) => {
    const {
        buttons: buttonsSlot,
        children: childrenSlot,
        leftAddons: leftAddonsSlot,
        subAddons: subAddonsSlot,
        title: titleSlot,
    } = useNamedContainersWithChildren(children);

    /**
     * useNamedContainersWithChildren всегда возвращает children в виде массива.
     * Если children не передан, будет пустой массив, который при приведении к Boolean == true.
     * В Core/Plate стоит проверка `const foldable = !!title && !!children && foldableProp;`
     * Она отрабатывает некорректно, так как !![] === true;
     * */
    const otherChildren = childrenSlot && childrenSlot.length ? childrenSlot : undefined;

    const renderTitle = () => (
        <Text tag="div" view={getTextView(config, titleView)}>
            {title}
        </Text>
    );

    return (
        <CorePlate
            buttons={buttonsSlot || buttons}
            className={className}
            leftAddons={leftAddonsSlot || leftAddons}
            rounded={rounded}
            subAddons={subAddonsSlot || subAddons}
            title={titleSlot || (title && renderTitle())}
            titleView={titleView}
            view={view}
            {...restProps}
        >
            {/** В новой версии убран отступ 4px сверху. Для обратной совместимости */}
            {otherChildren && <div className={styles.plateDescription}>{otherChildren}</div>}
        </CorePlate>
    );
};
